import { Preferences } from '@capacitor/preferences';

const STORAGE_KEY = 'authToken';

class AuthTokenUtil {
  private authToken: string | null = null;
  private isSynced = false;

  constructor() {
    // Preference adds prefix to storage key, migrating the old key here
    const localAuthToken = localStorage.getItem(STORAGE_KEY);
    if (localAuthToken) {
      this.set(localAuthToken);
      localStorage.removeItem(STORAGE_KEY);
    } else {
      this.getAsync().then();
    }
  }

  private setCachedAuthToken(token: typeof this.authToken) {
    this.authToken = token;
    this.isSynced = true;
  }

  get() {
    if (!this.isSynced) {
      throw new Error(
        "AuthTokenUtil hasn't been synced with storage before being used.",
      );
    }

    return this.authToken;
  }

  async getAsync() {
    const { value: token } = await Preferences.get({ key: STORAGE_KEY });
    this.setCachedAuthToken(token);
    return token;
  }

  set(token: string) {
    this.setCachedAuthToken(token);
    return Preferences.set({ key: STORAGE_KEY, value: token });
  }

  remove() {
    this.setCachedAuthToken(null);
    return Preferences.remove({ key: STORAGE_KEY });
  }
}

export default new AuthTokenUtil();
